import { useMemo } from 'react';
import { TMultiSelectItem } from '../../ui/multi-select';

export const useVisibilitySwitchers = <T>(selected: TMultiSelectItem<T>[], hiddenCount: number) => {
  const isMoreCountShown = useMemo(() => {
    return !!selected.length && !!hiddenCount;
  }, [hiddenCount, selected.length]);

  const isCloseIconShown = useMemo(() => {
    return !!selected.length;
  }, [selected.length]);

  return {
    isMoreCountShown,
    isCloseIconShown
  };
};
